import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Calendar, BookOpen } from 'lucide-react';

const steps = [
  {
    icon: MessageSquare,
    title: 'Get in touch',
    desc: 'Reach out via the contact form and tell me about your goals and challenges.',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-600',
  },
  {
    icon: Calendar,
    title: 'Free session',
    desc: "We'll find a time that works for you and plan your personalised learning path.",
    iconBg: 'bg-pink-50',
    iconColor: 'text-pink-500',
  },
  {
    icon: BookOpen,
    title: 'Start learning',
    desc: 'Dive into engaging, personalised sessions designed to help you understand and succeed.',
    iconBg: 'bg-green-50',
    iconColor: 'text-green-600',
  },
];

const HowItWorks = () => {
  return (
    <section id="courses" className="py-20 md:py-28 bg-neutral-50">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="font-display text-[36px] md:text-[44px] tracking-tight font-semibold text-neutral-900"
        >
          How it works.
        </motion.h2>

        <div className="mt-12 grid md:grid-cols-3 gap-5 md:gap-6">
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                whileHover={{ y: -6 }}
                className="bg-white rounded-2xl p-8 shadow-[0_1px_3px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgba(0,0,0,0.08)] transition-shadow duration-300"
              >
                <div className={`${step.iconBg} ${step.iconColor} w-12 h-12 rounded-xl flex items-center justify-center`}>
                  <Icon size={22} strokeWidth={2} />
                </div>
                <h3 className="mt-6 font-display text-[20px] font-semibold text-neutral-900">{step.title}</h3>
                <p className="mt-3 text-[14px] leading-[1.65] text-neutral-600">{step.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
